module.exports = __webpack_public_path__ + "static/key-shadowsawakening-36f68eae6ceb5d2c45a77e7dbf2844d9.webp";